import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
import { Page } from '../../components/Page';

export const TodayQuestProgressPageSkeleton: FC = () => {
  return (
    <Page>
      <Stack height="100%" justifyContent="center">
        <Stack direction="column" padding="20px" gap="15px" sx={{ overflow: 'hidden' }}>
          <Stack direction="column" alignItems="center" gap="10px" sx={{ flexShrink: 0 }}>
            <ThemedSkeleton variant="text" width={120} height={40} />
            <ThemedSkeleton variant="text" width={100} height={20} />
          </Stack>
          
          <Stack 
            direction="column"
            alignItems="center"
            gap="10px" 
            sx={{ 
              overflowY: 'auto',
              flex: 1,
              minHeight: 0,
              paddingBottom: '80px'
            }}
          >
            {Array.from({ length: 3 }).map((_, i) => (
              <ThemedSkeleton key={i} variant="rectangular" width="100%" height={60} sx={{ borderRadius: 1.5 }} />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Page>
  );
};

